(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-lunifique-style-selector"] && !Shopify.designMode) return;
  try {
    
(function () {
  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function updateSelectedCard(grid, selectedCard) {
    grid.querySelectorAll('[data-lfl-style-card]').forEach(function (card) {
      var isSelected = card === selectedCard;
      card.classList.toggle('is-current', isSelected);
      card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  function findNativeRadio(title) {
    var normalizedTitle = normalize(title);
    var radios = document.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i += 1) {
      if (normalize(radios[i].value) === normalizedTitle) return radios[i];
    }
    return null;
  }

  function syncUrl(variantId) {
    if (!variantId || !window.history || !window.URL) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url.toString());
  }

  function isMobileCarousel() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function centerMobileCard(card) {
    if (!card || !isMobileCarousel()) return;
    window.setTimeout(function () {
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }, 0);
  }

  function scrollToNextProductStep(card) {
    if (!card || !isMobileCarousel()) return;
    var styleSection = card.closest('.lfl-styles-section') || card.closest('.lfl-styles');
    var productSection = document.querySelector('.section-featured-product, .main-product-section');
    if (!styleSection || !productSection) return;

    var styleTop = styleSection.getBoundingClientRect().top + window.pageYOffset;
    var productTop = productSection.getBoundingClientRect().top + window.pageYOffset;
    if (productTop <= styleTop) return;

    var target = productSection.querySelector('variant-selects, .product-form__input--swatches, product-info') || productSection;
    window.setTimeout(function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 220);
  }

  function scrollStyleGrid(control) {
    var section = control.closest('.lfl-styles');
    var grid = section && section.querySelector('[data-lfl-style-grid]');
    if (!grid) return;

    var direction = control.getAttribute('data-lfl-style-scroll') === 'next' ? 1 : -1;
    var card = grid.querySelector('[data-lfl-style-card]');
    var styles = window.getComputedStyle(grid);
    var gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
    var step = card ? card.getBoundingClientRect().width + gap : grid.clientWidth * 0.86;

    grid.scrollBy({ left: step * direction, behavior: 'smooth' });
  }

  document.addEventListener('click', function (event) {
    var control = event.target.closest('[data-lfl-style-scroll]');
    if (control) {
      event.preventDefault();
      scrollStyleGrid(control);
      return;
    }

    var card = event.target.closest('[data-lfl-style-card]');
    if (!card) return;

    event.preventDefault();

    var grid = card.closest('[data-lfl-style-grid]');
    var variantId = card.getAttribute('data-variant-id');
    var variantTitle = card.getAttribute('data-variant-title');
    var radio = findNativeRadio(variantTitle);

    if (radio) {
      if (!radio.checked) radio.click();
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (grid) updateSelectedCard(grid, card);
    centerMobileCard(card);
    scrollToNextProductStep(card);
    syncUrl(variantId);
  });
}());

  } catch(e) { console.error(e); }
})();
})();
